import { HttpLink } from 'apollo-link-http';

import { GRAPHQL_URI } from '../../config';

const httpLink = new HttpLink({
  uri: GRAPHQL_URI,
});

export default httpLink;
